import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/Footer";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import LanguageSwitcher from "@/components/LanguageSwitcher/LanguageSwitcher";

type LayoutProps = {
  children: React.ReactNode;
  breadcrumbItems?: { label: string; href?: string }[];
  locale?: "pt" | "en";
};

export default function SiteLayout({ locale = "pt", children, breadcrumbItems }: LayoutProps) {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-1 bg-[#F7F2E3] text-gray-900">
        <div className="max-w-7xl mx-auto relative">
          {breadcrumbItems && <Breadcrumb items={breadcrumbItems} locale={locale} />}
          {children}
        </div>
      </main>

      <Footer />

      {/* Floating language switcher */}
      <LanguageSwitcher />
    </div>
  );
}
